// Broadcast channel name for passing username auth token from popup window back to parent window
// Docs: https://developer.mozilla.org/en-US/docs/Web/API/Broadcast_Channel_API
export const USERNAME_AUTH_BROADCAST_CHANNEL = 'USERNAME_AUTH_BROADCAST_CHANNEL';
